import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Playlists.svg'

export const IconPlaylists = IconSVG as IconComponent
